import React from 'react';
import PageLayout from '@/components/layout/HomePageLayout';
import SEOHead from '@/components/seo/SEOHead';
import DesignerGrid from '@/components/DesignerGrid';

const Designers: React.FC = () => {
  return (
    <PageLayout>
      <SEOHead 
        title="Designers - World Class Design"
        description="Discover talented designers from around the world"
      />
      
      <div className="relative z-30 bg-white">
        {/* Warm gradient background applied to the content area */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute warm-gradient"></div>
          <div
            className="absolute inset-0 opacity-40"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z' fill='%23FFDFCE' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E\")",
              opacity: "0.4",
            }}
          ></div>
        </div>

        {/* Hero Section */}
        <div className="relative mb-6">
          <div className="container mx-auto px-4 md:py-20 relative z-20 my-[10px] pt-12 md:pb-6 pb-0">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-3xl md:text-7xl font-normal mb-1 md:mb-8 tracking-tight animate-fade-in text-gray-900 font-prociono"
              style={{
                background: "linear-gradient(90deg, #231617 0%, #89565A 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent"
              }}
              >
                The Standard for  <br /> Design Talent Worldwide
              </h1>
              
              <p className="text-sm md:text-base text-black mb-0 md:mb-8 animate-fade-in" style={{
                animationDelay: '0.2s'
              }}>
                We make great designers easy to find and trust
              </p>
            </div>
          </div>
        </div>
        
        <div className="container mx-auto px-4">
          <DesignerGrid />
        </div>
      </div>
    </PageLayout>
  );
};

export default Designers; 